import { render } from "./IsAdmin.vue?vue&type=template&id=1344b3a8&scoped=true"
import script from "./IsAdmin.vue?vue&type=script&lang=js"
export * from "./IsAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1344b3a8"]])

export default __exports__